import { useEffect } from "react";
import { Shell } from "../components";
import { setPageMetadata } from "../page-metadata";

export function NotFoundPage() {
  useEffect(() => {
    setPageMetadata(
      "Bomana 页面未找到 | CheemsPay",
      "你访问的 Bomana 页面不存在，或链接已经失效。",
    );
  }, []);

  return (
    <Shell back={{ href: "/", label: "返回首页" }}>
      <section className="single-card-page not-found-page">
        <article className="single-card dashboard-card centered">
          <h1>找不到这个页面</h1>
          <p className="muted">链接可能已失效，或地址写错了。</p>
          <a className="button anchor-button" href="/">
            返回首页
          </a>
        </article>
      </section>
    </Shell>
  );
}
